export enum COMPLIANCE_TASK_TYPE {
  criminal = 'criminal',
  environmental = 'environmental',
  fiscal = 'fiscal',
  labor = 'labor'
}
